import { useRef } from "react";
import type { FC } from "react";
import { Box, Grid, IconButton, Link, Typography } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { AnyContext } from "@hookstate/core";
import { PropsLocationCard } from "../../../../config/interfaces";
import "./index.scss";
import { Delete } from "@mui/icons-material";
import {
  Location,
  useDeleteLocationMutation,
} from "../../../../../graphql/generated/graphql";
import { setAlertDescription } from "../../../../hooks/actions";

const LocationCard: FC<PropsLocationCard | any> = ({
  location,
  openModal,
  index,
  isEdit,
  refetch,
  rearrangeLocation,
}) => {
  const [deleteLocationMutation, { data, loading, error }] =
    useDeleteLocationMutation();
  const ref = useRef<HTMLDivElement>(null);

  const deleteLocation = async (loc: Location) => {
    await deleteLocationMutation({
      variables: {
        locations: [loc.id],
      },
    }).then((res) =>
      setAlertDescription({
        open: true,
        message: "The Location has been deleted",
        severity: "success",
      })
    );
    if (refetch) {
      refetch();
    }
  };

  return (
    <div
      className="location-card"
      onClick={() => rearrangeLocation(location.id)}
      ref={ref}
    >
      <div className="location-card-title">
        <h3>
          <span
            className={`location-card-number ${!location.order ? "hide" : ""}`}
          >
            Location {location.order}
          </span>
          {location.name}
        </h3>
        <Grid className="location-card-button-action">
          <Box
            sx={{
              display: "flex",
            }}
          >
            {isEdit && (
              <Typography
                component="p"
                variant="h2"
                className="p-right"
              >
                <IconButton onClick={() => openModal(location)}>
                  <EditIcon />
                </IconButton>
              </Typography>
            )}
            {isEdit && (
              <Typography
                component="p"
                variant="h2"
                className="p-right"
              >
                <IconButton onClick={() => deleteLocation(location)}>
                  <Delete />
                </IconButton>
              </Typography>
            )}
          </Box>
        </Grid>
      </div>
      <div className="location-card-wrapper">
        <div className="location-card-box">
          <img src="https://cinemahive.s3.amazonaws.com/images/locations/Group+71515.svg" />
          <h3>SET ADDRESS</h3>
          <p>{location.set_address}</p>
          <Link
            target="_blank"
            variant="h5"
            color="secondary"
            href={location.link_maps_set_address}
          >
            View Map →
          </Link>
        </div>
        <div className="location-card-box">
          <img src="https://cinemahive.s3.amazonaws.com/images/locations/Group+71514.svg" />
          <h3>PARKING INSTRUCTIONS</h3>
          <p>{location.parking_instructions}</p>
        </div>
        <div className="location-card-box">
          <img src="https://cinemahive.s3.amazonaws.com/images/locations/Group+71513.svg" />
          <h3>LOCATION CONTACT </h3>
          <p>{location.location_contact}</p>
        </div>
        <div className="location-card-box">
          <img src="https://cinemahive.s3.amazonaws.com/images/locations/Group+71516.svg" />
          <h3>PARKING ADDRESS</h3>
          <p>{location.parking_address}</p>
          {location?.link_maps_parking_address !== '' &&
            <Link
              target="_blank"
              variant="h5"
              color="secondary"
              href={location.link_maps_parking_address}
            >
              View Map →
            </Link>
          }

        </div>

        <div className="location-card-box">
          <img src="https://cinemahive.s3.amazonaws.com/images/locations/Group+71517.svg" />
          <h3>NEAREST HOSPITAL</h3>
          <p>{location.nearest_hospital_address}</p>
          {location?.link_maps_hospital_address !== '' &&
            <Link
              target="_blank"
              variant="h5"
              color="secondary"
              href={location.link_maps_hospital_address}
            >
              View Map →
            </Link>
          }
        </div>
        <div className="location-card-box">
          {location.files.length > 0 &&
            <img src="https://cinemahive.s3.amazonaws.com/images/locations/Group+71518.svg" />
          }
          {location.files &&
            location.files.map((file: AnyContext) => (
              <a
                className="location-link-file"
                target="_blank"
                href={file.file}
                key={file.id}
              >
                {file.file_name}
              </a>
            ))}

        </div>
      </div>
    </div>
  );
};

export default LocationCard;
